import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { RouterModule } from '@angular/router';

import { NavBarItemBase } from '@core/config';
import { MwDirectivesModule } from '@core/directives/directives.module';
import { MW_MENU_ITEMS } from '@core/injection-tokens';

import { MwAppModulesModule } from './@components/app-modules/app-modules.module';
import { MwAppToolbarModule } from './@components/app-toolbar';
import { MwNavListModule } from './@components/nav-list/nav-list.module';
import { MwNewsModule } from './@components/news/news.module';
import { MwProfileMenuModule } from './@components/profile-menu/profile-menu.module';
import { MwSidebarModule } from './@components/sidebar/sidebar.module';
import { MwLayoutComponent } from './layout.component';
import { MW_LAYOUT_OPTIONS } from './layout.options';
import { MwLayoutService } from './layout.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MatIconModule,
    MatButtonModule,
    MwAppToolbarModule,
    MwDirectivesModule,
    MwNavListModule,
    MwSidebarModule,
    MwAppModulesModule,
    MwProfileMenuModule,
    MwNewsModule,
  ],
  exports: [MwLayoutComponent],
  declarations: [MwLayoutComponent],
  providers: [],
})
export class MwLayoutModule {
  static forRoot(
    menuItems: NavBarItemBase[],
    opts?: {
      clickableTitle?: boolean;
    }
  ): ModuleWithProviders<MwLayoutModule> {
    return {
      ngModule: MwLayoutModule,
      providers: [
        MwLayoutService,
        {
          provide: MW_MENU_ITEMS,
          useValue: menuItems,
        },
        {
          provide: MW_LAYOUT_OPTIONS,
          useValue: opts,
        },
      ],
    };
  }
}
